import { render, staticRenderFns } from "./PsiSimpleTable.vue?vue&type=template&id=55a6bc55&scoped=true&"
import script from "./PsiSimpleTable.vue?vue&type=script&lang=js&"
export * from "./PsiSimpleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a6bc55",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55a6bc55')) {
      api.createRecord('55a6bc55', component.options)
    } else {
      api.reload('55a6bc55', component.options)
    }
    module.hot.accept("./PsiSimpleTable.vue?vue&type=template&id=55a6bc55&scoped=true&", function () {
      api.rerender('55a6bc55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/src/components/tables/PsiSimpleTable.vue"
export default component.exports